<script lang="ts">
  import CarrotShoppableUnit from "./CarrotShoppableUnit.svelte";
  import KevelShoppableUnit from "./KevelShoppableUnit.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import { isEmpty } from "lodash";

  export let shoppableUnit;
  export let shouldFetchData: boolean = false;
  export let pageName: string | null = null;
  // discovery panel passes this in automatically but
  // trying to not do that anymore and just use the store
  export let mobileMode: boolean = false;
</script>

{#if stagedRolloutCheck("kevel_ads")}
  {#if !isEmpty(shoppableUnit)}
    <KevelShoppableUnit {shoppableUnit} {shouldFetchData} {pageName} {mobileMode} />
  {/if}
{:else}
  <CarrotShoppableUnit {shoppableUnit} {shouldFetchData} {pageName} {mobileMode} />
{/if}
